import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var GoogleColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.511 22.494a25.3 25.3 0 0 0-.4-4.493H22.459v8.509h11.836a10.073 10.073 0 0 1-4.388 6.637v5.526h7.086a21.484 21.484 0 0 0 6.518-16.179Z",
    svgColor: "#4285F4"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.395 43.992a21.01 21.01 0 0 0 14.56-5.32l-7.112-5.525a13.227 13.227 0 0 1-7.448 2.104 13.098 13.098 0 0 1-12.3-9.038H2.75v5.707a21.947 21.947 0 0 0 19.645 12.072Z",
    svgColor: "#34A853"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.094 26.174a12.916 12.916 0 0 1 0-8.354v-5.733H2.75a21.956 21.956 0 0 0 0 19.768l7.344-5.681Z",
    svgColor: "#FBBC05"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.395 8.743a11.899 11.899 0 0 1 8.416 3.292l6.299-6.314A21.126 21.126 0 0 0 22.395.001 21.937 21.937 0 0 0 2.75 12.114l7.344 5.707a13.105 13.105 0 0 1 12.301-9.077Z",
    svgColor: "#EA4335"
  }));
});
GoogleColor.displayName = 'GoogleColor';
GoogleColor.defaultProps = {
  'aria-label': 'GoogleColor'
};
export default GoogleColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/GoogleColor.js
// module id = 2949
// module chunks = 11